(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["druzzer-one-page"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('submit', async (event) => {
  const form = event.target;
  if (!(form instanceof HTMLFormElement) || !form.matches('.dr-package-form')) return;
  event.preventDefault();
  if (form.dataset.busy === 'true') return;
  form.dataset.busy = 'true';
  const button = form.querySelector('button[type="submit"]');
  const error = form.querySelector('.dr-package-error');
  button.disabled = true;
  error.hidden = true;
  const data = new FormData(form);
  const items = [];
  for (let index = 0; data.has('items[' + index + '][id]'); index++) {
    items.push({id: data.get('items[' + index + '][id]'), quantity: Number(data.get('items[' + index + '][quantity]'))});
  }
  try {
    const response = await fetch(form.dataset.addUrl, {method:'POST', headers:{'Content-Type':'application/json',Accept:'application/json'}, body:JSON.stringify({items})});
    if (!response.ok) throw new Error('Cart request failed');
    window.location.assign(form.dataset.cartUrl);
  } catch {
    error.hidden = false;
    button.disabled = false;
    delete form.dataset.busy;
  }
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
